import { cn } from '#/shared/lib/utils'

export type StatusBadgeVariant = 'success' | 'neutral' | 'warning' | 'danger'

const PILL_CLASS: Record<StatusBadgeVariant, string> = {
  success: 'bg-green-50 text-green-700',
  neutral: 'bg-gray-100 text-gray-500',
  warning: 'bg-orange-50 text-orange-500',
  danger: 'bg-red-50 text-red-500',
}

const DOT_CLASS: Record<StatusBadgeVariant, string> = {
  success: 'bg-green-600',
  neutral: 'bg-gray-300',
  warning: 'bg-orange-500',
  danger: 'bg-red-500',
}

interface StatusBadgeProps {
  /** Shorthand for the success/neutral pair. Ignored when `variant` is set. */
  active?: boolean
  /** Explicit color variant; takes precedence over `active`. */
  variant?: StatusBadgeVariant
  children: React.ReactNode
}

export function StatusBadge({ active, variant, children }: StatusBadgeProps) {
  const resolved: StatusBadgeVariant = variant ?? (active ? 'success' : 'neutral')

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-xs font-medium',
        PILL_CLASS[resolved],
      )}
    >
      <span className={cn('size-2 rounded-full', DOT_CLASS[resolved])} />
      {children}
    </span>
  )
}
